import { faker } from '@faker-js/faker/locale/es';
import type { Person, Plant, Station } from './types';

const ROLE_MIX: Array<{ value: Person['role']; weight: number }> = [
  { value: 'operator', weight: 0.65 },
  { value: 'supervisor', weight: 0.15 },
  { value: 'quality_engineer', weight: 0.10 },
  { value: 'maintenance', weight: 0.08 },
  { value: 'director', weight: 0.02 },
];

const SHIFTS: Person['shift'][] = ['morning', 'afternoon', 'night'];
const CERTS = ['ISO-9001', 'CE', 'IPC-A-610', 'Soldadura MIG', 'SAP MES', 'ISO-45001', 'EASA Part 21', 'Carretillero'];

function deptFor(role: Person['role']): string {
  switch (role) {
    case 'operator':
    case 'supervisor':
      return 'Producción';
    case 'quality_engineer':
      return 'Calidad';
    case 'maintenance':
      return 'Mantenimiento';
    case 'director':
      return 'Dirección';
  }
}

export function generatePeople(plants: Plant[], stations: Station[], count: number = 45): Person[] {
  const people: Person[] = [];
  for (let i = 0; i < count; i++) {
    const firstName = faker.person.firstName();
    const lastName = faker.person.lastName();
    const role = faker.helpers.weightedArrayElement(ROLE_MIX);
    const plant = faker.helpers.arrayElement(plants).id;
    const shift = faker.helpers.arrayElement(SHIFTS);
    const stationAssignments =
      role === 'operator'
        ? faker.helpers.arrayElements(
            stations.filter((s) => s.plant === plant).map((s) => s.id),
            { min: 1, max: 3 },
          )
        : [];
    people.push({
      id: `EMP-${String(1000 + i).padStart(4, '0')}`,
      fullName: `${firstName} ${lastName}`,
      firstName,
      lastName,
      avatar: `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(firstName + lastName)}`,
      role,
      shift,
      department: deptFor(role),
      plant,
      email: faker.internet.email({ firstName, lastName }).toLowerCase(),
      phone: `+34 6${faker.string.numeric(2)} ${faker.string.numeric(2)} ${faker.string.numeric(2)} ${faker.string.numeric(2)}`,
      certifications: faker.helpers.arrayElements(CERTS, { min: 0, max: 3 }),
      hireDate: faker.date.past({ years: 15 }).toISOString().split('T')[0],
      stationAssignments,
    });
  }
  return people;
}
